import { FaList, FaMapMarkedAlt } from "react-icons/fa";
import styles from "./OpenCloseButton.module.scss";
import Image from "next/image";
import { BiChevronRight } from "react-icons/bi";

export default function OpenCloseButton({ active, onClick, size = 30 }) {
  const icons = {
    map: <FaMapMarkedAlt size={size} color="inherit"></FaMapMarkedAlt>,
    arrowRight: <BiChevronRight size={size} color="inherit" />,
  };

  return (
    <button
      className={`${styles.button} ${active ? "" : styles.clicked}`}
      onClick={onClick}
      name="toggle-map-overlay"
      aria-label="Toggle map overlay"
    >
      <span className={`${styles.buttonContent}`}>
        {active && icons.arrowRight}
        {!active && icons.map}
      </span>
    </button>
  );
}
